import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ApiConstant } from "../constants/app.constant";
import { SnackBarService } from "../services/snack-bar/snack-bar.service";
import { AuthSignInService } from "../services/authentication/auth-signin.service";

declare var $: any;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _SnackbarServ: SnackBarService,
    private _AuthSigninService: AuthSignInService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this._AuthSigninService._LoginSimulation) {
      return next.handle(req);
    }

    // Skip authentication check for public endpoints
    const publicEndpoints = [
      "Account/VerifyEmail",
      "Account/Login",
      "Account/Register",
      "Account/ForgotPassword",
    ];

    const isPublicEndpoint = publicEndpoints.some((endpoint) =>
      req.url.includes(endpoint)
    );

    if (!isPublicEndpoint) {
      let expiresIn = sessionStorage.getItem("expires")
        ? atob(sessionStorage.getItem("expires"))
        : null;

      if (
        sessionStorage.getItem("token") == null ||
        sessionStorage.getItem("token").length < 10 ||
        expiresIn == null ||
        new Date(expiresIn).getTime() < Date.now()
      ) {
        this._router.navigate(["/auth/signin"]);
      }
    }

    // if (req.url.includes(ApiConstant.baseUrlCoreApi)) {
    //   var Token =
    //     sessionStorage.getItem("tokenCore") !== null &&
    //     sessionStorage.getItem("tokenCore") !== undefined &&
    //     sessionStorage.getItem("tokenCore")?.length > 20
    //       ? atob(sessionStorage.getItem("tokenCore"))
    //       : "";

    //   req = req.clone({
    //     setHeaders: {
    //       "Content-Type": "application/json; charset=utf-8",
    //       Accept: "application/json",
    //       Authorization: `${Token}`,
    //     },
    //   });

    // } else {

    // Only add Authorization header for authenticated requests
    if (!isPublicEndpoint) {
      var Token =
        sessionStorage.getItem("token") !== null &&
        sessionStorage.getItem("token") !== undefined &&
        sessionStorage.getItem("token")?.length > 20
          ? atob(sessionStorage.getItem("token"))
          : "";

      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json; charset=utf-8",
          Accept: "application/json",
          Authorization: `${Token}`,
        },
      });
    } else {
      // For public endpoints, only add content-type headers
      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json; charset=utf-8",
          Accept: "application/json",
        },
      });
    }
    // }

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Handle HttpResponse events if needed
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          // console.error('An error occurred:', JSON.stringify(error));
          // return throwError(error);
        } else {
          // console.error(
          //   `Backend returned code ${error.status}, ` +
          //   `body was: ${JSON.stringify(error)}`
          // );

          if (
            error.status === 410 ||
            error.status === 503 ||
            error.status === 504
          ) {
            if (error.status === 410 || error.status === 504) {
              this._SnackbarServ.SetPremiseDown(true);
              $("#exampleModal").modal("show");
            }

            if (error.status === 503) {
              this._SnackbarServ.SetCloudDown(true);
              $("#exampleModal").modal("show");
            }
          } else {
            //console.error(`An unknown error occurred`);
          }
        }

        return throwError(error);
      })
    );
  }
}
